import React from 'react'
import {Row,Col, Modal , ModalBody,ModalFooter,ModalHeader,Input,InputGroup,Button } from 'reactstrap'
import {LoadingSpinner} from './../../components'
import Services from './../../services/Services'

class AttachImageModal extends React.Component{
  constructor(props){
    super(props)
    this.state={
      loading:false,
      image:null,
      file:null,
      serviceGroup:this.props.serviceGroup,
    }
  }
  uploadImage(data){
    this.setState({loading:true})
    Services.uplaodServiceGroupImage(this.state.serviceGroup.id,data,res => {
      this.setState({loading:false},()=>{this.clear();this.props.closeHandler()})
    })
  }
  
  handleImageChange(e){
    e.preventDefault();
    let reader = new FileReader();
    let file = e.target.files[0];
    reader.onloadend = () => {
      this.setState({
        file: file,
        image: reader.result,
      });
    }
    reader.readAsDataURL(file)
  }
  clearImg(){
    this.setState({
      image:null,
      file:null,
    })
  }
  fakeUpload(){
    document.getElementById('image-uploader2').click();
  }
  clear(){
    this.setState({image:null,file:null,serviceGroup:null})
  }
  validateRequest(){
    if (this.state.file == null) {
      alert('please upload image first')
      return false
    }
    return true
  }
  submit(){
    if(this.validateRequest()){
      let data = new FormData();
      data.append('image',this.state.file)
      this.uploadImage(data)
    }
  }
  render(){
    return(
      <>
      <Modal fade={true} isOpen={this.props.isOpen} toggle={()=>{this.clear();this.props.toggleHandler()}}>
        <ModalHeader toggle={()=>{this.clear();this.props.toggleHandler()}}>Attach Image</ModalHeader>
        <ModalBody>
        <div style={{padding:'20px'}}>
            <label style={{textAlign:'center'}}><strong>Add Image</strong></label>
            <InputGroup>
              <Button className='actionsBtn' onClick={()=>this.fakeUpload()}>Upload Image</Button>
              <Input id='image-uploader2' type='file' accept="image/x-png,image/gif,image/jpeg" onChange={(e)=>this.handleImageChange(e)}/>
              {this.state.image?(
              <>
              <Row>
                <Col md="4" style={{marginBottom:8,padding:'15px'}}>
                    <div id='image-eraser' className='shadow' style={{width:'100%'}}>
                      <Button onClick={()=>this.clearImg()} color="danger">
                            <img src={this.state.image} width='100%' height='100%'/>
                      </Button>
                      <span onClick={()=>this.clearImg()} className='icon-close' id='image-eraser-icon'></span>
                    </div>
                </Col>
              </Row>
              </>
              ):null}
            </InputGroup>
          </div>
        </ModalBody>
        <ModalFooter>
              <Button className='actionsBtn' onClick={()=>{this.clear();this.props.closeHandler()}}>Close</Button>
              <Button className='actionsBtn' onClick={()=>this.submit()}>Confirm</Button>
        </ModalFooter>
      </Modal>
      <LoadingSpinner loading={this.state.loading} />
      </>
    )
  }
}
export default AttachImageModal;
